import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CardLayoutModule } from 'src/app/common-components/card-layout/card-layout.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { DeletePhoneNumberDialogModule } from 'src/app/common-components/delete-phone-number-dialog/delete-phone-number-dialog.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { ReleasePhoneNumberDialogModule } from 'src/app/common-components/release-phone-number-dialog/release-phone-number-dialog.module';
import { TooltipModule } from 'src/app/common-components/tooltip/tooltip.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { PhoneNumberDetailComponent } from './containers/phone-number-detail.component';
import { PhoneNumberDetailEffects } from './state/phone-number-detail.effects';
import * as fromPhoneNumberDetail from './state/phone-number-detail.reducer';
import { PhoneNumberDetailViewComponent } from './views/phone-number-detail-view.component';

@NgModule({
   declarations: [PhoneNumberDetailViewComponent, PhoneNumberDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      RouterModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      LcsDatepickerModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      EntitySelectModule,
      StoreModule.forFeature(fromPhoneNumberDetail.phoneNumberDetailFeatureKey, fromPhoneNumberDetail.reducer),
      EffectsModule.forFeature([PhoneNumberDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
      ErrorPageModule,
      CardLayoutModule,
      FormatPhoneNumbersPipeModule,
      ReleasePhoneNumberDialogModule,
      DeletePhoneNumberDialogModule,
      TooltipModule,
   ],
})
export class PhoneNumberDetailModule {}
